import Enum from "../../../../enums/Enum";

const IntakeFormYesNoEnum = new Enum({
    Yes: {name: "Yes", nameInArabic: "نعم"},
    No: {name: "No", nameInArabic: "لا"},

});

export default IntakeFormYesNoEnum;